<template>
    <div id="what-we-do">
        <div>
            <container>
                <h1>What do you do and why should we do business with you?</h1>
                <br />
                Our committed and sincere staff solves complex, mission critical problems. Providing secure,
                compliant, low risk solutions.
                <br />
                Among many other services and inventories, our expert staff can provision, provide, and support the following:
                <spacer />
                <row :align="'start'" :justify="'around'">
                    <column :width="2/7" v-for="(item, index) in wwd" :key="index">
                        <expandBox @expand="expand" :currentIndex="currentIndex" :thisIndex="index" :title="item.title" :items="item.items" />
                    </column>
                </row>
            </container>
            <spacer />
        </div>
    </div>
</template>

<script>
import expandBox from '../components/expand-box';
import wwd from '../json/what-we-do';
export default {
    name: 'WhatWeDo',
    data () {
        return {
            wwd,
            currentIndex: -1
        }
    },
    components: {
        expandBox
    },
    methods: {
        expand(index) {
            this.currentIndex = index;
        }
    }
}
</script>

<style scoped>
    .background-cloud {
        background: #0683c9 url("../assets/background/cloud.jpg") no-repeat fixed center;
		background-size: cover;
    }
    .background-network {
        background: #0683c9 url("../assets/background/network.jpg") no-repeat fixed center;
		background-size: cover;
    }
    @media (orientation: landscape) and (min-width: 1281px) {
        .border-left {
            border-left-style: solid;
            border-left-color: white;
            border-left-width: 1px;
            text-align: left;
        }
        .left {
            text-align: left;
        }
    }
</style>
